<template>
    <el-container class="mainPage">
        <el-header>
            <div class="midBlock">
                <!-- <img src="/static/images/utils/logow_1.png" class="marLogo"> -->
                <div class="marSysTit">{{ sysName }}</div>

                <el-dropdown @command="rightDropdown" trigger="click">
                    <span class="el-dropdown-link">
                        {{userName}}<i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="mine">个人信息</el-dropdown-item>
                        <el-dropdown-item command="logout">{{$t('login.logout')}}</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
                <!-- <i class="el-icon-message-solid topFunIcon" @click="showMsgBox">
                    <span id="unReadIcon" v-if="unReadCount">{{unReadCount}}</span>
                </i> -->
            </div>
        </el-header>
        <el-container class="rightContainer">
            <el-aside :width="isCollapse?'64px':'200px'">
                <!-- 3bb4d4 8c335a -->
                <el-scrollbar style="height: calc(100% - 0px); z-index: 10; margin-top: 0px; background-size: cover; background-image: url('/static/images/pic/bg1.jpg');">
                    <!-- background-image: linear-gradient(to bottom, #077cf5, #2c335a); -->
                    <el-menu class="" @open="handleOpen" @close="handleClose" :unique-opened="true" :collapse="isCollapse">
                        <template v-for="(item) in menuAll" :index='item.id.toString()'>
                            <el-menu-item v-if="item.url" :key="item.id" :index='item.id.toString()' @click="addTab(item.url, item.name)" class="selectNone">
                                <div class="dots">
                                    <i :class="'iconfont'" v-html="item.icon?item.icon:'&#xe7cc;'"></i>
                                    <span :title="item.name">{{item.name}}</span>
                                </div>
                            </el-menu-item>
                            <el-submenu v-else :key="item.id" :index="item.id.toString()" class="selectNone">
                                <template slot="title">
                                    <div class="dots">
                                        <i :class="'iconfont'" v-html="item.icon?item.icon:'&#xe7cc;'"></i>
                                        <span :title="item.name">{{item.name}}</span>
                                    </div>
                                </template>

                                <template v-for="(child) in item.children" :index='child.id.toString()'>
                                    <el-menu-item v-if="child.url" :key="child.id" :index='child.id.toString()' @click="addTab(child.url, child.name)" class="selectNone menuLev2">{{child.name}}
                                    </el-menu-item>

                                    <el-submenu v-else :key="child.id" :index="child.id.toString()" class="selectNone">
                                        <template slot="title">
                                            <div class="dots" :title="child.name">{{child.name}}</div>
                                        </template>

                                        <template v-for="(child2) in child.children" :index='child2.id.toString()'>
                                            <el-menu-item :key="child2.id" :index='child2.id.toString()' @click="addTab(child2.url, child2.name)" class="selectNone menuLev2">{{child2.name}}
                                            </el-menu-item>
                                        </template>

                                    </el-submenu>
                                </template>

                            </el-submenu>
                        </template>
                    </el-menu>
                </el-scrollbar>
                <div class="colpBtn" @click="toggleCollapse" :style="'left:'+(isCollapse?'19px':'175px')+'; bottom:10px;'">
                    <i :class="isCollapse?'el-icon-s-unfold':'el-icon-s-fold'"></i>
                </div>
            </el-aside>
            <el-main>
                <el-row style="height: 100%;">
                    <el-col :span="24" style="height: 100%;">
                        <el-tabs id="mainTabs" v-model="currTabName" type="card" @tab-remove="removeTab" @tab-click="clickTab" style="height: 100%;">
                            <el-tab-pane v-for="(item) in tabArr" :key="item.name" :label="item.title" :name="item.name" :closable="item.closable">
                                <span slot="label">
                                    <span class="span-box">
                                        <i :class="'iconfont topBarIcon'" v-html="item.icon?item.icon:'&#xe7cc;'"></i>
                                        <span>{{item.title }}</span>
                                    </span>
                                </span>

                                <keep-alive>
                                    <tab-component :is="item.content" :key="item.ts" @addTab="addTab" @closeTab="closeTab" @refreshTab="refreshTab" :curr="currTabName==item.name" :param="item.param"></tab-component>
                                </keep-alive>
                            </el-tab-pane>
                        </el-tabs>
                    </el-col>
                </el-row>
            </el-main>
        </el-container>

        <el-dialog :title="centerDialogTit" :width="centerDialogWidth" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="true" :visible.sync="centerDialogVisible" v-if="centerDialogVisible" append-to-body>
            <component :is="centerComp.con" :key="centerComp.ts" :param="centerComp.param" @closeCallback="centerDialogVisible=false" @confirmCallback="centerConfirmCallback"></component>
        </el-dialog>

        <el-drawer :title="hcComp.title" :visible.sync="hcVisible" :size="hcComp.size" :with-header="false" append-to-body>
            <component :is="hcComp.con" :key="hcComp.ts" :param="hcComp.param" @closeCallback="hcVisible=false" @comCallback="comCallback"></component>
        </el-drawer>

    </el-container>
</template>

<script>
export default {
    name: "index",
    components: {},
    data () {
        return {
            sysName: config.sysName,
            circleUrl: "",
            menuAll: [],
            menuBase: [],
            menuTopIndex: 0, // 选中的顶部菜单
            homePath: '/dashboard', // /dashboard
            currTabName: '',
            tabArr: [],
            userNo: '',
            userName: '',
            entName: '',
            phone: '',
            isCollapse: false,
            unReadCount: 0,

            hcComp: {},
            hcVisible: false,

            centerDialogTit: '',
            centerDialogVisible: false,
            centerComp: {},
            centerDialogWidth: '50%',
        };
    },
    methods: {
        handleOpen (key, keyPath) {
            // console.log(key, keyPath);
        },
        handleClose (key, keyPath) {
            // console.log(key, keyPath);
        },
        refreshTab: function (path) {
            let _this = this;
            if (path.indexOf("?") != -1) {
                let n = path.indexOf("?");
                path = path.substring(0, n);
            }

            let name = path.replaceAll('/', '');
            this.tabArr.forEach((tab, index) => {
                if (tab.name === name) {
                    _this.$set(_this.tabArr[index], "ts", new Date().getTime());
                }
            });
        },
        clearTab: function () {
            // 关闭首页以外的其他tab
            let _this = this;
            this.tabArr.forEach((tab, index) => {
                if (tab.name != 'dashboard') {
                    _this.removeTab(tab.name);
                }
            });
        },
        addTab (path, title, param, self) {
            if (!path) {
                this.$message({
                    showClose: true,
                    message: this.$t('menu.unConfig'),
                    type: 'warning'
                })
                return;
            }
            if (self == undefined) {
                self = false;
            }

            if (path.indexOf("?") != -1) {
                if (!param) {
                    param = {};
                }
                // 解析参数
                let n = path.indexOf("?");
                let paramStr = path.substr(n + 1);
                let paramArr = paramStr.split("&");
                paramArr.forEach(function (nn, i) {
                    let arr = nn.split("=");
                    param[arr[0]] = arr[1];
                });

                path = path.substring(0, n);
            }


            let name = path.replaceAll('/', '');
            let pagePath = path;

            var comp = () => import('@/components' + pagePath + '.vue');
            if (!param) {
                param = {};
            }
            param.tabName = name;

            // TODO 拦截器此处进行判断权限

            // 是否已经打过该标签
            let has = false;
            let _this = this;
            this.tabArr.forEach((tab, index) => {
                if (tab.name === name || (self && _this.currTabName === tab.name)) {
                    has = true;
                    if (self) {
                        _this.$set(_this.tabArr[index], "param", param);
                        _this.$set(_this.tabArr[index], "content", comp);
                        _this.$set(_this.tabArr[index], "ts", new Date().getTime());
                    } else {
                        // 组件的key元素，如果变化，组件会从新渲染
                        _this.$set(_this.tabArr[index], "title", title);
                        _this.$set(_this.tabArr[index], "param", param);
                        _this.$set(_this.tabArr[index], "content", comp);
                        _this.$set(_this.tabArr[index], "ts", new Date().getTime());
                    }
                }
            });

            if (!has) {
                let icon = '';
                this.menuAll.forEach(function (n, i) {
                    if (n.children) {
                        n.children.forEach(function (nn, ii) {
                            if (nn.url == path) {
                                icon = nn.icon;
                            }
                            if (nn.children && nn.children.length > 0) {
                                nn.children.forEach(function (nnn, iii) {
                                    if (nnn.url == path) {
                                        icon = nnn.icon;
                                    }
                                });
                            }
                        });
                    }
                });

                if (!icon) {
                    // 特殊处理一些没有在sys_menu里配置的路径的icon
                    let iconObj = {
                        "/dashboard": "&#xe751;",
                    };
                    if (iconObj[path]) {
                        icon = iconObj[path];
                    }
                }

                this.tabArr.push({
                    title: title,
                    name: name,
                    icon: icon,
                    param: param,
                    content: comp,
                    closable: path == this.homePath ? false : true
                });
                // console.log(name + '----' + icon);
            }
            if (!self) {
                this.currTabName = name;
            }
        },
        removeTab (targetName) {
            // console.log('delete tab  :', targetName);
            let tabs = this.tabArr;
            let active = this.currTabName;
            if (active === targetName) {
                tabs.forEach((tab, index) => {
                    if (tab.name === targetName) {
                        let nextTab = tabs[index + 1] || tabs[index - 1];
                        if (nextTab) {
                            active = nextTab.name;
                        }
                    }
                });
            }

            this.currTabName = active;
            this.tabArr = tabs.filter(tab => tab.name !== targetName);
        },
        clickTab: function (e) {
            // console.log(e);
        },
        closeTab: function (path) {
            let targetName = this.currTabName;
            if (path) {
                targetName = path.replaceAll('/', '');
            }
            this.removeTab(targetName);
        },

        rightDropdown: function (command) {
            if (command == 'logout') {
                sessionStorage.removeItem("hwt-token");
                sessionStorage.removeItem("uid");
                sessionStorage.removeItem("userName");
                sessionStorage.removeItem("avatar");
                sessionStorage.removeItem("menuArr");
                sessionStorage.removeItem("funsArr");
                sessionStorage.removeItem("orgId");

                this.$router.push("/login");
            } else if (command == 'mine') {
                this.centerComp = {
                    con: () => import('@/components/sys/user_info_edit.vue'),
                    ts: new Date().getTime(),
                    param: {},
                };
                this.centerDialogTit = '个人信息';
                this.centerDialogWidth = '500px';
                this.centerDialogVisible = true;
            }
        },
        centerConfirmCallback: function (param) {
            this.centerDialogVisible = false;
            if (param.code && param.code == 'user_info_update') {
                this.userName = sessionStorage.getItem("userName");
                this.refreshTab('/dashboard');
            }
        },

        toggleCollapse: function () {
            this.isCollapse = !this.isCollapse;

            setTimeout(function () {
                var myEvent = new Event('resize');
                window.dispatchEvent(myEvent);
            }, 100);
        },
        resize: function () {
            let h = document.body.clientHeight;
            let w = document.body.clientWidth;
        },
        showMsgBox: function () {
            // this.$message.success('暂无消息');
            // this.hcComp = {
            //     con: () => import('@/components/sys/msg_comp.vue'),
            //     ts: new Date().getTime(),
            //     param: {},
            //     size: '50%',
            //     title: '消息通知',
            // };
            // this.hcVisible = true;
        },
        comCallback: function (param) {
            if (param.fun == 'reloadUnReadCount') {
            }
        },
        // loadSysName: function () {
        //     let _this = this;
        //     this.req('/common/qry_sys_param?type=SYS_PARAM_SYS_NAME&mult=false', {}, function (data) {
        //         if (data.success) {
        //             _this.sysName = data.obj.value;
        //         }
        //     }, 'get')
        // },
    },
    mounted: function () {

        this.$nextTick(function () {
            let _this = this;
            this.uid = sessionStorage.getItem("uid");
            this.userName = sessionStorage.getItem("userName");
            let menus = JSON.parse(sessionStorage.getItem("menuArr"));

            this.menuAll = menus;

            this.resize();
            window.addEventListener('resize', () => {
                this.resize();
            });
            // this.loadSysName();

            this.addTab('/dashboard', this.$t('tabName.dashboard'));

            let date = this.lib.timeFormat(new Date(), 'yyyy-mm-dd');
            this.$watermark.set(this.uid + "/" + this.userName + ' ' + date)

        });
    },
    beforeDestroy: function () {
        this.$watermark.remove();
    },
};
</script>
<style scoped>
.marLogo {
    height: 40px;
    display: block;
    float: left;
    margin-top: 10px;
    margin-right: 10px;
}
.marSysTit {
    color: #000;
    font-size: 28px;
    line-height: 60px;
    width: auto;
    float: left;
}
.el-container {
    height: 100%;
}
.el-header {
    background-color: #f1f8ff;
    background-image: url("/static/images/utils/topbg.png");
    background-size: contain;
    background-position: 90% 0px;
    background-repeat: no-repeat;
    color: #fff;
    text-align: center;
    line-height: 60px;
    padding: 0;
    border-bottom: 1px solid #e5e5e5;
}

.rightContainer {
    /* width: calc(100% - 200px); */
    width: 100%;
    height: calc(100% - 60px);
}

.midBlock {
    height: 60px;
    padding-left: 20px;
    padding-right: 20px;
    box-sizing: border-box;
    position: relative;
}

.el-aside {
    color: #333;
    height: 100%;
    background-size: cover;
    background-position: 50%;
    overflow: hidden;
}

.el-aside >>> .el-submenu [class^="el-icon-"] {
    margin-right: 0px;
}

.el-aside >>> .el-menu-item [class^="el-icon-"] {
    margin-right: 0px;
}

.el-aside >>> .el-submenu__title i {
    font-size: 18px;
    font-weight: 400;
    color: #000;
}
.el-aside >>> .el-submenu__title {
    color: #000;
}
.el-aside >>> .el-submenu__title span {
    padding-left: 0px;
}
.el-aside >>> .el-submenu__title:focus,
.el-aside >>> .el-submenu__title:hover {
    background-color: #409EFF33;
}
.el-aside >>> .el-menu-item i {
    font-size: 18px;
    font-weight: 400;
    color: #000;
}
.el-aside >>> .el-menu-item span {
    padding-left: 3px;
    color: #000;
}

.el-aside >>> .el-menu-item:focus,
.el-aside >>> .el-menu-item:hover {
    background-color: #409EFF33;
}

.menuLev2 {
    color: #000;
}
.el-menu--vertical .menuLev2 {
    background-color: #fff;
    color: #333;
}
.el-menu--vertical .menuLev2:hover {
    background-color: #e5e5e5;
}

.el-main {
    color: #333;
    height: 100%;
    /* background: url("/static/images/utils/elMainBk.png") repeat; */
    /* border-radius: 4px; */
    /* background-color: #f7f7f8; */
    /* background-image: url('/static/images/utils/topbk1.png');
    background-repeat: repeat-x; */
    background-color: #f2f3f5;
    /* background: linear-gradient(to top, #eee 85%, #a0c2a1 15%); */

    padding-right: 0px;
}

body > .el-container {
    margin-bottom: 40px;
}

#mainTabs >>> .el-tabs__content {
    height: calc(100% - 40px);
    overflow-y: auto;
    padding-right: 20px;
}

.el-aside >>> .el-scrollbar__wrap {
    overflow-x: hidden;
}

.el-header >>> .el-scrollbar__wrap {
    overflow-x: hidden;
}

.el-header >>> .el-scrollbar__wrap .el-scrollbar__view {
    white-space: nowrap;
}
.el-dropdown-menu {
    top: 60px !important;
}

/* */
.el-dropdown {
    float: right;
}
.el-dropdown-link {
    cursor: pointer;
    color: #000;
    font-size: 16px;
}
.el-icon-arrow-down {
    font-size: 12px;
    color: #000;
}

/** */
.alertTip {
    float: right;
    margin-right: 30px;
    line-height: 30px;
    margin-top: 15px;
    font-size: 16px;
    padding-right: 10px;
}

/** */
.searchInput {
    float: right;
    margin-right: 30px;
    width: 220px;
    box-sizing: border-box;
    /* margin-top: 10px; */
}
/* .searchInput .el-input-group__prepend {
    background-color: #fff;
}
.searchInput /deep/ .el-input__inner:focus {
    border-color: #dcdfe6;
} */

.handIcon {
    cursor: pointer;
    user-select: none;
}
.paginationDiv {
    margin-top: 20px;
}

.colpBtn {
    width: 25px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    position: absolute;
    z-index: 50;
    bottom: 0px;
    left: 0px;
    /* background-color: #f2f3f5;
    border-top-left-radius: 25px;
    border-bottom-left-radius: 25px; */
    cursor: pointer;
    box-sizing: border-box;
}
.colpBtn i {
    font-size: 20px;
    line-height: 50px;
    color: #000;
}

.alertDialog /deep/ .el-tabs__item {
    margin-right: 0px;
}
.saLine {
    text-align: left;
}

.sadt {
    font-weight: bold;
}

.topBarIcon {
    color: #666;
    font-size: 16px;
}
.is-active .topBarIcon {
    color: #077cf5;
}

.topFunIcon {
    display: block;
    float: right;
    width: 30px;
    line-height: 60px;
    text-align: center;
    font-size: 22px;
    margin-right: 10px;
    cursor: pointer;
    position: relative;
}

#unReadIcon {
    font-size: 11px;
    height: 18px;
    line-height: 18px;
    min-width: 18px;
    display: block;
    position: absolute;
    /* z-index: 9; */
    right: -5px;
    top: 10px;
    background-color: #f56c6c;
    color: #fff;
    border-radius: 18px;
}

.expSysItem {
    display: flex;
    justify-content: center; /* 垂直居中 */
    margin-bottom: 20px;
    padding: 10px 10px;
    gap: 10px;
}
.expIcon {
    color: #077cf5;
    width: 40px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    font-size: 28px;
}
.expName {
    flex: 1;
    line-height: 40px;
    font-size: 18px;
}
.expRowSel {
    background-color: #077cf522;
    border-radius: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/index.vue